import OrganisationGuidelinesTable from "./OrganisationGuidelinesTable";

export default OrganisationGuidelinesTable